import axios from '../utils/axios';

export default function deleteCourse(adminId, courseId, data) {
    return (
        axios.post('/admin/' + adminId +'/courses/course/delete/' + courseId,  data )
    )
}
